import React from "react";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
type OfferBlockProps = {
  label: string;
  id?: string;
};
export function OfferBlock({
  label,
  id
}: OfferBlockProps) {
  return <div className="mx-auto w-full max-w-xl" data-id="element-37" data-mp="3w3mj9fsy0uuz">
      <CTAButton label={label} id={id} data-id="element-38" data-mp="4w09r6jjly67" />
      <p className="mt-3 text-center text-sm leading-relaxed text-ink-muted" data-id="element-39" data-mp="4x309dcydyll">
        Instant Digital Access · One-Time Payment of <strong className="text-ink" data-id="element-40" data-mp="wm4zzltzhffc">$27 USD</strong> · Lifetime Access · 7-Day Guarantee
      </p>
      <div className="mt-7" data-id="element-41" data-mp="iurjyhvaazp2">
        <Countdown data-id="element-42" data-mp="ivjgbuwph1ge" />
      </div>
      <div className="mt-6" data-id="element-43" data-mp="iuht6s2f0oib">
        <ScarcityBar data-id="element-44" data-mp="ntuqy7utrfzo" />
      </div>
    </div>;
}